import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from './context/AppContext.jsx';
import App from './App.jsx';
import { initializePlugins } from './plugins/index.js';
import './index.css';

// Initialize plugin system with built-in plugins
initializePlugins();

ReactDOM.createRoot(document.getElementById('root')).render(
  <AppProvider>
    <App />
  </AppProvider>
);


